import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth/authConfig';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApiAnonymousService, ApiService } from './services/apiService';

// Crea l'istanza MSAL
const msalInstance = new PublicClientApplication(msalConfig);

const initializeApiService = async () => {
  
  // Funzione per ottenere il token in modo sincrono con l'istanza MSAL
  const getTokenFunction = async (): Promise<string | null> => {
    try {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length === 0) return null;

      const silentRequest = {
        // scopes: ["openid", "profile", "email", "api://8ee6e6e3-d508-4dee-99d1-3dfeb05fc3be/Admin.Access"],
        scopes: ["openid", "profile", "email", "api://0929920a-122c-4dc0-93d2-6fede34f0cb4/admin.acces"],
        account: accounts[0]
      };

      const response = await msalInstance.acquireTokenSilent(silentRequest);
      return response.accessToken;
    } catch (error) {
      console.error('Token acquisition failed:', error);
      return null;
    }
  };

  ApiService.initialize(getTokenFunction);
};

initializeApiService();
ApiAnonymousService.initialize();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: {}
    }
  }
});
appInsights.loadAppInsights();

appInsights.trackEvent({ name: "TestEvent" });